import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageMenu from '../../PageMenu';
import { colors } from '../../../styles';

const styles = css`
  @media (min-width: 992px) {
    background-color: transparent;
    padding: 30px 0 60px 0;
    ul {
      text-align: center !important;
      li a {
        color: ${colors.brand1Dark} !important;
        line-height: 30px !important;
        height: 29px;
        margin: 0 30px;
        border-radius: 14px;
        text-transform: none;
        font-size: 14px;
        font-weight: 700;
        margin: 0 10px;
        text-transform: uppercase;
        letter-spacing: 1px;
        border: 0 !important;
        &.active {
          color: ${colors.white} !important;
          background-color: ${colors.brand2} !important;
          border: 0 !important;
        }
      }
    }
  }
`;

function PhotoGalleryMenu({ page, ...props }) {
  const categoryLinks = _.get(page, 'photo_gallery', []).map(g => ({
    name: 'photo-gallery-filtered',
    params: { gallery: _.get(g, 'category_name') },
    title: _.get(g, 'category_name'),
  }));

  return (
    <PageMenu
      {...props}
      className={styles}
      title="Photo Gallery Categories"
      items={[
        // {
        //   name: 'photo-gallery',
        //   title: 'All Photos',
        // },
      ].concat(categoryLinks)}
    />
  );
}

PhotoGalleryMenu.propTypes = {
  page: PropTypes.arrayOf(PropTypes.object).isRequired,
};

PhotoGalleryMenu.defaultProps = {
};

export default PhotoGalleryMenu;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PhotoGalleryMenu.section.js